export const formatTariffEndDate = (dateString: string) => {
	const options: any = { month: 'short', day: 'numeric', year: 'numeric' };
	const date = new Date(dateString);
	return date.toLocaleDateString('en-US', options);
};
